import { render } from "./ReconConfig.vue?vue&type=template&id=2c22b71a&scoped=true"
import script from "./ReconConfig.vue?vue&type=script&lang=js"
export * from "./ReconConfig.vue?vue&type=script&lang=js"

import "./ReconConfig.vue?vue&type=style&index=0&id=2c22b71a&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c22b71a"]])

export default __exports__